import {Modal, ModalBody} from "reactstrap";
import Register from "./Register";
import SMSCode from "./SmsCode";
import {useTranslation} from "react-i18next";
import {useState} from "react";
import {useSelector} from "react-redux";

const DemoRequest = ({isOpen, toggle}) => {
    const {t} = useTranslation();

    const [isSMSCode, setIsSMSCode] = useState(false);
    const [userId, setUserId] = useState(null);
    const [SMSCode, setSMSCode] = useState(null);

    const {isForDemo} = useSelector(state => state.requestDemo);

    const changeSMSCode = (code) => {
        setSMSCode(code);
    }

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered
            modalClassName={"zoomIn"}
            fullscreen={"sm"}
        >
            <div className="modal-header py-3 px-4 bg-primary">
                <h5 className="text-white mb-0">
                    {isForDemo ? t('t-use-demo-version') : t('t-use-demo-version2')}
                </h5>
                <span className="cursor-pointer" onClick={toggle}>
                    <i className="ri-close-line fs-22 text-white"></i>
                </span>
            </div>
            <ModalBody className={"p-4"}>
                {!isSMSCode
                    ? <Register toggle={changeSMSCode} changeUSerID={setUserId}/>
                    : isSMSCode
                        ? <SMSCode user_id={userId} toggle={changeSMSCode}/>
                        : <>
                            <div className="text-center mt-3">
                                <h4 className="text-success">{t('t-request-accepted')}</h4>
                                <p className="fs-14">{t('t-connect')}</p>
                            </div>
                            <div className="text-end mt-5">
                                <button className="btn btn-light" onClick={toggle}>
                                    {t('t-close')}
                                </button>
                            </div>
                        </>}
            </ModalBody>
        </Modal>
    )
}

export default DemoRequest;